import SEO from "../../components/SEO";
import ScrollDepthTracker from "../../components/ScrollDepthTracker";
import SeriesNavigation from "../../components/SeriesNavigation";
import FadeInSection from "../../components/FadeInSection";
import { clinicalTrials } from "../../data/navigationData";

export default function STARS() {
  const STARSSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "STARS",
    "url": "https://www.thrombio.com.au/trials/STARS",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "MedicalEntity",
      "name": "TBO-309",
      "description": "TBO-309 is a novel antiplatelet compound currently in Phase II clinical trials for the treatment of acute ischemic stroke."
    }
  };

  return (
    <>
      <SEO
        title="STARS"
        description="Dive into our clinical trial and discover TBO-309's breakthroughs in therapies redefining patient recovery and care, and learn about our research advancing adjunctive antithrombotic therapies to safely improve thrombolysis and prevent rethrombosis"
        keywords={['Acute Ischaemic Stroke', 'Large Vessel Occlusion', 'Clinical Trials', 'STARS', 'Blood Clots', 'Stroke Treatment', 'tPA', 'Thrombectomy', 'Brain injury', 'Brain infarction', 'Recanalization', 'Reperfusion', 'Penumbra', 'AIS', 'RtPA', 'Antithrombotic', 'TBO-309', 'Adjunctive therapy']}
        ogImage="/starslogo2.webp"
        schema={STARSSchema}
        clinicalTrial={true}
        drugInformation={true}
      />
      <ScrollDepthTracker pageCategory="trials" pageName="stars" />

      <div className="xl:page-width px-12 pt-[80px] md:pt-44 text-[2.1rem] leading-[3.1rem] tracking-[.042rem] overflow-hidden">

        {/* Header Section with Logo and Title */}
        <div className="flex flex-col mb-[120px]">
          {/* Mobile Layout */}
          <div className="md:hidden flex flex-col items-center">
            <FadeInSection>
              <div className="text-white text-[4.2rem] font-bold leading-[52px] tracking-[0.141rem] [text-shadow:_0px_4px_9px_rgb(0_0_0_/_1.00)] text-center]">
                Clinical Trials
              </div>
            </FadeInSection>
            <div className="overflow-hidden w-full">
              <FadeInSection direction="right" className="delay-500">
                <div className="text-[#DA0912] text-[7rem] font-bold leading-[52px] tracking-[0.141rem] [text-shadow:_0px_4px_9px_rgb(0_0_0_/_1.00)] font-syne text-center mb-10">
                  STARS
                </div>
              </FadeInSection>
            </div>

            <FadeInSection className="delay-1000">
              <div className="mb-8">
                <img src="/starslogo2.webp" alt="STARS Clinical Trial Logo" className="h-[325px] w-auto" />
              </div>
            </FadeInSection>

            <div className="flex flex-col text-left text-[2.2rem] md:text-[2.8rem] leading-[3.6rem] tracking-[.08rem] text-[#E0FFFF] font-syne font-light w-full max-w-[300px]">
              <FadeInSection className="delay-[1500ms]" skipDelayOnScroll>
                <div><span className="font-bold text-[2.7rem]">S</span>afety</div>
              </FadeInSection>
              <FadeInSection className="delay-[2000ms]" skipDelayOnScroll>
                <div><span className="font-bold text-[2.7rem]">T</span>olerability and efficacy of</div>
              </FadeInSection>
              <FadeInSection className="delay-[2500ms]" skipDelayOnScroll>
                <div><span className="font-bold text-[2.7rem]">A</span>djunctive TBO-309 in</div>
              </FadeInSection>
              <FadeInSection className="delay-[3000ms]" skipDelayOnScroll>
                <div><span className="font-bold text-[2.7rem]">R</span>eperfusion for</div>
              </FadeInSection>
              <FadeInSection className="delay-[3500ms]" skipDelayOnScroll>
                <div><span className="font-bold text-[2.7rem]">S</span>troke</div>
              </FadeInSection>
            </div>
          </div>

          {/* Desktop/Tablet Layout */}
          <div className="hidden md:block">
            <div className="flex items-baseline gap-16 mb-12">
              <FadeInSection>
                <div className="text-white text-[3.6rem] md:text-[4.5rem] font-bold leading-[52px] tracking-[0.141rem] [text-shadow:_0px_4px_9px_rgb(0_0_0_/_1.00)]">
                  Clinical Trials
                </div>
              </FadeInSection>
              <div className="overflow-hidden">
                <FadeInSection direction="right" className="delay-500">
                  <div className="text-[#DA0912] text-[6rem] md:text-[7.5rem] font-bold leading-[52px] tracking-[0.141rem] [text-shadow:_0px_4px_9px_rgb(0_0_0_/_1.00)] font-syne">
                    STARS
                  </div>
                </FadeInSection>
              </div>
            </div>

            <div className="flex items-end gap-16 w-full max-w-[120ch]">
              <FadeInSection className="flex-shrink-0 delay-1000">
                <img src="/starslogo2.webp" alt="STARS Clinical Trial Logo" className="h-[325px] w-auto" />
              </FadeInSection>

              <div className="flex flex-col text-left text-[2.4rem] md:text-[2.8rem] leading-[3.6rem] tracking-[.08rem] text-[#E0FFFF] font-syne font-light">
                <FadeInSection className="delay-[1500ms]" skipDelayOnScroll>
                  <div><span className="font-bold">S</span>afety</div>
                </FadeInSection>
                <FadeInSection className="delay-[2000ms]" skipDelayOnScroll>
                  <div><span className="font-bold">T</span>olerability and efficacy of</div>
                </FadeInSection>
                <FadeInSection className="delay-[2500ms]" skipDelayOnScroll>
                  <div><span className="font-bold">A</span>djunctive TBO-309 in</div>
                </FadeInSection>
                <FadeInSection className="delay-[3000ms]" skipDelayOnScroll>
                  <div><span className="font-bold">R</span>eperfusion for</div>
                </FadeInSection>
                <FadeInSection className="delay-[3500ms]" skipDelayOnScroll>
                  <div><span className="font-bold">S</span>troke</div>
                </FadeInSection>
              </div>
            </div>
          </div>
        </div>

          <div className="flex flex-col max-w-[80ch] mt-[120px] md:mt-[90px]">
            <div className="pt-[90px] md:pt-[24px]">
        <FadeInSection>
              <div className="pb-[10px]">Stroke is one of Australia's most challenging healthcare problems — more than 50,000 Australians are affected by a stroke every year, and over half end up with permanent disability.</div>
             </FadeInSection> 
                     <FadeInSection>
              <div className="pb-[10px]">For more than 40 years, researchers worldwide have tried and failed to develop a clot-targeting drug safe enough to use in acute stroke treatment; every previous attempt risked causing fatal brain bleeding. The STARS trial exists because that problem may finally have a solution.</div>
              </FadeInSection>
                      <FadeInSection>
              <div className="pb-[10px]">TBO-309 is a new drug, built on 30 years of Australian research, that works by blocking only the abnormal clotting process responsible for strokes — leaving the body's normal, healthy clotting ability intact. This precision matters: it means TBO-309 may be able to dissolve dangerous clots, including the microscopic blockages in the brain's tiniest vessels that no existing treatment can reach, without the bleeding risk that has made previous drugs too dangerous.</div>
              </FadeInSection>
                      <FadeInSection>
              <div className="pb-[10px]">This Phase II trial — running across stroke units in NSW, Victoria, and South Australia — is the critical next step in establishing whether TBO-309 is safe and effective for the emergency treatment of stroke.</div>
           </FadeInSection>
            </div>
          </div>

        <div className="flex flex-col max-w-[80ch] mt-[120px] md:mt-[90px]">
          <div>
            <FadeInSection>
              <div className="text-[#E0FFFF] max-md:text-center md:w-full font-syne text-[3.3rem] font-bold leading-[3.2rem] tracking-[.165rem]">
                Brief Summary
              </div>
            </FadeInSection>
          </div>
          <FadeInSection>
            <div className="pt-[40px] md:pt-[24px]">
              STARS is a prospective, multi centre, open-label, dose escalation, Phase IIa study to assess the safety and
              tolerability of TBO-309, an adjuvant antiplatelet therapy, in patients with Acute ischaemic stroke (AIS).
              AIS is caused by a severe blockage of an artery leading to immediate reduced blood flow to part of the
              brain. Standard therapies target the blocked artery by either dissolving the blockage or removing the
              blockage. However, even after the successful treatment, re-blockage of arteries can occur. The use of an
              antiplatelet therapy, TBO-309, in addition to standard therapies, offers the possibility of improved
              restoration of blood flow and reduced rates of artery re-blockage.
            </div>
          </FadeInSection>
        </div>

        <div className="flex flex-col max-w-[80ch] mt-[120px] md:mt-[90px]">
          <div>
            <FadeInSection>
              <div className="text-[#E0FFFF] max-md:text-center md:w-full font-syne text-[3.3rem] font-bold leading-[3.2rem] tracking-[.165rem]">
                Background
              </div>
            </FadeInSection>
          </div>
          <FadeInSection>
            <div className="pt-[40px] md:pt-[24px]">
              Existing stroke therapies, such as rtPA, are far from optimal. Most patients are either unable to access this life saving therapy in time,
              or fail to achieve maximal benefit from the drug. Failure of this therapy is due primarily to its inability to adequately dissolve the clot
              (thrombolysis), as well as prevent the subsequent recurrence of a clot.
            </div>
          </FadeInSection>
          <FadeInSection>
            <div>
              The addition of other anti-clotting drugs (adjunct anti-thrombotic therapies) can improve thrombolysis and prevent reformation of the blood clot.
              This approach has been used successfully in heart attack patients for decades. Unfortunately, in stroke, combining rtPA with anti-clotting agents,
              such as aspirin, is associated with unacceptable high rates of bleeding in the brain, worsening patient outcomes.
            </div>
          </FadeInSection>
        </div>

        <div className="pt-24 grid md:grid-cols-2 gap-20 md:gap-8 xl:gap-24 max-w-[92.2rem]">
          <FadeInSection>
            <div className="border-[6px] border-[#C3EEFD] rounded-[4rem] px-8 xl:px-16 pb-12 pt-[23px] flex flex-col gap-6">
              <div className="text-center text-[2.5rem] font-medium leading-[3.6rem]">The Problem</div>
              <div className="text-[1.8rem] xl:text-[2rem] text-center leading-[2.6rem] tracking-[.036rem] xl:tracking-[0.08] flex flex-col gap-10">
                <div>
                  Antithrombotic drugs such as aspirin and heparin, administered as adjunct therapy to thrombolysis and/or
                  thrombvectomy, are routinely used in the coronary circulation to remove pathological blood clots.
                </div>
                <div>
                  However, their acute use in stroke is currently contraindicated, due to unacceptably high rates of
                  intracerebral bleeding.
                </div>
              </div>
            </div>
          </FadeInSection>
          <FadeInSection>
            <div className="border-[6px] border-[#C3EEFD] rounded-[4rem] px-8 xl:px-16 pb-12 pt-[23px] flex flex-col gap-6">
              <div className="text-center text-[2.5rem] font-medium leading-[3.6rem]">The Solution</div>
              <div className="text-[1.8rem] xl:text-[2rem] text-center leading-[2.6rem] tracking-[.036rem] xl:tracking-[0.08] flex flex-col gap-10">
                <div>
                  Advances in adjunctive antithrombotic therapies that can safely improve thrombolysis and prevent
                  rethrombosis, would likely have a profound impact on the hyperacute management of stroke.
                </div>
                <div>TBO-309 is currently being trialled in stroke patients in Phase II clinical trials.</div>
              </div>
            </div>
          </FadeInSection>
        </div>

        <FadeInSection>
          <div className="pt-32 pb-36 flex justify-center md:hidden">
            <img src="/3_AIS.svg" alt="" />
          </div>
        </FadeInSection>

        <div className="overflow-hidden">
          <FadeInSection direction="right">
            <div>
              <img src="/framephases.webp" alt="" className="md:hidden" />
              <img src="/phases2b2.webp" alt="" className="hidden md:max-xl:block py-28" />
              <img src="/framephasesd.webp" alt="" className="max-xl:hidden py-28 w-[92.2rem]" />
            </div>
          </FadeInSection>
        </div>

        <div className="py-36 flex justify-center md:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="18" viewBox="0 0 30 18" fill="none">
            <circle cx="9" cy="9" r="9" transform="matrix(-1 0 0 1 18.2144 0)" fill="#8E0000" />
            <circle cx="9" cy="9" r="9" transform="matrix(-1 0 0 1 29.7856 0)" fill="#C3EEFD" />
          </svg>
        </div>

        <div className="flex flex-col items-center gap-10 md:px-24">
          <FadeInSection>
          <div className="flex flex-col gap-2 items-center md:font-normal">
            <div>Clinical Trials ID:</div>
            <div className="text-[3.4rem] md:text-[2.5rem] xl:text-[3.6rem] font-syne leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem]">
              NCT05363397
            </div>
          </div>
          </FadeInSection>
          <FadeInSection>
          <div className="flex flex-col gap-4 items-center md:font-normal">
            <div>Sponsor:</div>
            <div className="text-[3.4rem] md:text-[2.5rem] xl:text-[3.6rem] font-syne leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem]">
              Florey Institute
            </div>
          </div>
          </FadeInSection>
          <FadeInSection>
          <div className="flex flex-col gap-4 items-center md:font-normal">
            <div>Collaborator:</div>
            <div className="text-[3.4rem] md:text-[2.5rem] xl:text-[3.6rem] font-syne leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem]">
              Thrombio Holdings Pty. Ltd.
            </div>
          </div>
          </FadeInSection>
          <FadeInSection>
          <div className="flex flex-col gap-4 items-center md:font-normal">
            <div>Recruiting:</div>
            <div className="font-syne text-[3rem] md:text-[2.5rem] xl:text-[3.6rem] leading-[2.7rem] md:leading-[3.4rem] tracking-[.03rem] md:tracking-[.125rem] xl:tracking-[.03rem]">
              Patient recruitment ongoing
            </div>
          </div>
          </FadeInSection>
        </div>

        <div className="pt-[150px] md:pt-[110px] flex flex-col md:items-center gap-[75px]">

          <div className="flex flex-col gap-[75px] md:grid md:grid-cols-[repeat(2,max-content)] md:justify-evenly md:gap-x-0 md:gap-y-8 w-full">
            <FadeInSection className="md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    The Royal Melbourne Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">Victoria</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Bruce Campbell</div>
                </div>
              </div>
            </FadeInSection>
            <FadeInSection className="md:delay-500 md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    John Hunter Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">NSW</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Chris Levi</div>
                </div>
              </div>
            </FadeInSection>
          </div>
          <div className="flex flex-col gap-[75px] md:grid md:grid-cols-[repeat(2,max-content)] md:justify-evenly md:gap-x-0 md:gap-y-8 w-full">
            <FadeInSection className="md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Royal Adelaide Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">South Australia</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Tim Kleinig</div>
                </div>
              </div>
            </FadeInSection>
            <FadeInSection className="md:delay-500 md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Liverpool Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">NSW</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Mark Parsons</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Dr. Chris Blair</div>
                </div>
              </div>
            </FadeInSection>
          </div>
          <div className="flex flex-col gap-[75px] md:grid md:grid-cols-[repeat(2,max-content)] md:justify-evenly md:gap-x-0 md:gap-y-8 w-full">
            <FadeInSection className="md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Prince of Wales Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">NSW</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Ken Butcher</div>
                </div>
              </div>
            </FadeInSection>
            <FadeInSection className="md:delay-500 md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Box Hill Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">Victoria</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Professor Philip Choi</div>
                </div>
              </div>
            </FadeInSection>
          </div>
          <div className="flex flex-col gap-[75px] md:grid md:grid-cols-[repeat(2,max-content)] md:justify-evenly md:gap-x-0 md:gap-y-8 w-full">
            <FadeInSection className="md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Princess Alexandra Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">Queensland</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Dr. Michael Devlin</div>
                </div>
              </div>
            </FadeInSection>
            <FadeInSection className="md:delay-500 md:grid md:grid-rows-subgrid md:row-span-2">
              <div className="flex flex-col gap-8 md:grid md:grid-rows-subgrid md:row-span-2">
                <div className="w-[300px] md:pb-4 flex flex-col items-center md:justify-center mx-auto md:mx-0">
                  <div className="text-center text-[3.4rem] md:text-[3.5rem] xl:text-[4rem] leading-[3.9rem] tracking-[.034rem] md:tracking-[.125rem] xl:tracking-[.03rem] font-bold text-[#E0FFFF]">
                    Gold Coast University Hospital
                  </div>
                  <div className="font-syne font-bold text-[1.8rem] leading-[2.5rem] tracking-[.09rem] text-center pt-4">Queensland</div>
                </div>
                <div className="text-center">
                  <div className="text-[1.8rem] leading-[2.5rem] tracking-[.09rem]">Principal Investigator</div>
                  <div className="text-[2.1rem] leading-[3.2rem] tracking-[.063rem]">Dr. Peter Bailey</div>
                </div>
              </div>
            </FadeInSection>
          </div>
        </div>
      </div>
      <SeriesNavigation
        items={clinicalTrials}
        currentSlug="stars"
        basePath="/trials"
      />
    </>
  );
}